// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.buttonFlat-module_floatButton__jPNC8 {
    font: var(--typography-secondary);
    color: var(--button-flat-text);
    background: var(--button-flat-bg);
    border-radius: 12px;
    display: inline-flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 33.33%;
    max-width: 150px;
    white-space: nowrap;
    padding: 16px;
    border: none;
    outline: none;
    cursor: pointer;

    @media (hover: hover) and (pointer: fine) {
        &:hover {
            background: var(--button-flat-bg-hovered);
        }
    }

    &:focus-visible,
    &:active {
        background: var(--button-flat-bg-pressed);
    }
}

.buttonFlat-module_floatButtonDisabled__jaf1m {
    color: var(--button-flat-text-disabled);
    pointer-events: none;
    cursor: not-allowed;

    @media (hover: hover) and (pointer: fine) {
        &:hover {
            background: none;
        }
    }

    &:focus-visible,
    &:active {
        background: none;
    }
}
`, "",{"version":3,"sources":["webpack://./../../packages/consumer/src/widgets/Buttons/styles/buttonFlat.module.css"],"names":[],"mappings":"AAAA;IACI,iCAAiC;IACjC,8BAA8B;IAC9B,iCAAiC;IACjC,mBAAmB;IACnB,oBAAoB;IACpB,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,YAAY;IACZ,aAAa;IACb,eAAe;;IAEf;QACI;YACI,yCAAyC;QAC7C;IACJ;;IAEA;;QAEI,yCAAyC;IAC7C;AACJ;;AAEA;IACI,uCAAuC;IACvC,oBAAoB;IACpB,mBAAmB;;IAEnB;QACI;YACI,gBAAgB;QACpB;IACJ;;IAEA;;QAEI,gBAAgB;IACpB;AACJ","sourcesContent":[".floatButton {\n    font: var(--typography-secondary);\n    color: var(--button-flat-text);\n    background: var(--button-flat-bg);\n    border-radius: 12px;\n    display: inline-flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    width: 33.33%;\n    max-width: 150px;\n    white-space: nowrap;\n    padding: 16px;\n    border: none;\n    outline: none;\n    cursor: pointer;\n\n    @media (hover: hover) and (pointer: fine) {\n        &:hover {\n            background: var(--button-flat-bg-hovered);\n        }\n    }\n\n    &:focus-visible,\n    &:active {\n        background: var(--button-flat-bg-pressed);\n    }\n}\n\n.floatButtonDisabled {\n    color: var(--button-flat-text-disabled);\n    pointer-events: none;\n    cursor: not-allowed;\n\n    @media (hover: hover) and (pointer: fine) {\n        &:hover {\n            background: none;\n        }\n    }\n\n    &:focus-visible,\n    &:active {\n        background: none;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"floatButton": `buttonFlat-module_floatButton__jPNC8`,
	"floatButtonDisabled": `buttonFlat-module_floatButtonDisabled__jaf1m`
};
export default ___CSS_LOADER_EXPORT___;
